/**
 * 规则：
 * - 用户名：允许字母、数字、下划线、点、连字符，但不能以点开头/结尾，不能连续两个点
 * - 域名：允许字母、数字、点、连字符，支持多级子域名（如 mail.example.com）
 * - 顶级域名：1-2级字母后缀（如 .com 或 .co.uk）
 *
 * 注意：此正则表达式在实用性和严格性之间做了平衡，允许常见的邮箱格式，
 * 但可能无法完全覆盖 RFC 5322 标准的所有边缘情况。
 */
export const EMAIL_REGEX =
  /^[0-9a-zA-Z_-]+([.][0-9a-zA-Z_-]+)*@([0-9a-zA-Z]([0-9a-zA-Z-]*[0-9a-zA-Z])?\.)+[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

// 旧版
// export const EMAIL_REGEX = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
